import { createRouter, createWebHistory } from "vue-router";
import Layout from "../components/Layout.vue";
import Login from "../components/Login.vue";
import Signup from "../components/Signup.vue";
import ResetPassword from "../components/ResetPassword.vue";
import NotFound from "../views/NotFound.vue";
import LandingPage from "../views/LandingPage.vue";
import CancellationPolicy from "../views/policies/CancellationPolicy.vue";
import RefundPolicy from "../views/policies/RefundPolicy.vue";
import PrivacyPolicy from "../views/policies/PrivacyPolicy.vue";
import TermsAndConditions from "../views/policies/TermsAndConditions.vue";
import AboutUs from "../views/policies/AboutUs.vue";
import Legals from "../views/policies/Legals.vue";

const routes = [
  {
    path: "/",
    name: "LandingPage",
    component: LandingPage,
    meta: {
      requiresAuth: false,
      activeModule: "landing",
      activeScreen: "Landing Page",
    },
  },
  {
    path: "/",
    component: Layout,
    children: [
      {
        path: "analytics-dashboard",
        name: "AnalyticsDashboard",
        component: () => import("../views/Dashboard.vue"),
        meta: {
          activeModule: "analytics-dashboard",
          activeScreen: "Analytics Dashboard",
        },
      },
      {
        path: "dashboard",
        name: "Dashboard",
        component: () => import("../views/Overalldashboared.vue"),
        meta: { activeModule: "dashboard", activeScreen: "Main Dashboard" },
      },
      {
        path: "conversations",
        name: "Conversations",
        component: () => import("../views/Conversations.vue"),
        meta: {
          activeModule: "conversations",
          activeScreen: "Conversations List",
        },
      },
      {
        path: "conversations/:id",
        name: "ConversationDetail",
        component: () => import("../views/Conversations.vue"),
        meta: {
          activeModule: "conversations",
          activeScreen: "Conversation Detail",
        },
      },
      {
        path: "cross-platform-control",
        name: "CrossPlatformControl",
        component: () => import("../views/CrossPlatformControl.vue"),
        meta: {
          activeModule: "cross-platform-control",
          activeScreen: "Cross Platform Control",
        },
      },
      {
        path: "collaborative-content-tools",
        name: "CollaborativeContentTools",
        component: () => import("../views/CollaborativeContentTools.vue"),
        meta: {
          activeModule: "collaborative-content-tools",
          activeScreen: "Collaborative Content Tools",
        },
      },
      {
        path: "content-library",
        name: "ContentLibrary",
        component: () => import("../views/ContentLibrary.vue"),
        meta: {
          activeModule: "content-library",
          activeScreen: "Content Library",
        },
      },
      // {
      //   path: "ab-testing",
      //   name: "ABTesting",
      //   component: () => import("../views/ABTesting.vue"),
      // },
      {
        path: "content-gap-insights",
        name: "ContentGapInsights",
        component: () => import("../views/ContentGapInsights.vue"),
        meta: {
          activeModule: "content-gap-insights",
          activeScreen: "Content Gap Insights",
        },
      },
      {
        path: "calendar",
        name: "Calendar",
        component: () => import("../views/Calendar.vue"),
        meta: { activeModule: "calendar", activeScreen: "Calendar" },
      },
      {
        path: "settings",
        name: "Settings",
        component: () => import("../views/Settings.vue"),
        meta: { activeModule: "settings", activeScreen: "Settings" },
      },
      {
        path: "fan-insights",
        name: "FanInsights",
        component: () => import("../views/FanInsights.vue"),
        meta: { activeModule: "fan-insights", activeScreen: "Fan Insights" },
      },
      {
        path: "mobile-experience",
        name: "MobileExperience",
        component: () => import("../views/MobileExperience.vue"),
        meta: {
          activeModule: "mobile-experience",
          activeScreen: "Mobile Experience",
        },
      },
      {
        path: "authentic-voice-ai",
        name: "AuthenticVoiceAI",
        component: () => import("../views/AuthenticVoiceAI.vue"),
        meta: {
          activeModule: "authentic-voice-ai",
          activeScreen: "Authentic Voice AI",
        },
      },
      {
        path: "analytics",
        name: "Analytics",
        component: () => import("../views/Analytics.vue"),
        meta: { activeModule: "analytics", activeScreen: "Analytics" },
      },
      {
        path: "monetization-hub",
        name: "MonetizationHub",
        component: () => import("../views/MonetizationHub.vue"),
        meta: {
          activeModule: "monetization-hub",
          activeScreen: "Monetization Hub",
        },
      },
      {
        path: "profile",
        name: "Profile",
        component: () => import("../views/Profile.vue"),
        meta: { activeModule: "profile", activeScreen: "Profile" },
      },
      {
        path: "subscription",
        name: "Subscription",
        component: () => import("../views/Subscription.vue"),
        meta: { activeModule: "subscription", activeScreen: "Subscription" },
      },
      {
        path: "/smart-content-tagging",
        name: "SmartContentTagging",
        component: () => import("../views/SmartContentTagging.vue"),
        meta: {
          activeModule: "smart-content-tagging",
          activeScreen: "Smart Content Tagging",
        },
      },
      {
        path: "/revenue-optimization",
        name: "RevenueOptimization",
        component: () => import("../views/RevenueOptimization.vue"),
        meta: {
          activeModule: "revenue-optimization",
          activeScreen: "Revenue Optimization",
        },
      },
      {
        path: "/security-privacy",
        name: "security-privacy",
        component: () => import("../views/security-privacy.vue"),
        meta: {
          activeModule: "security-privacy",
          activeScreen: "Security & Privacy",
        },
      },
      {
        path: "/onboarding&migration",
        name: "Onboarding&Migration",
        component: () => import("../views/OnboardingMigration.vue"),
        meta: {
          activeModule: "onboarding-migration",
          activeScreen: "Onboarding & Migration",
        },
      },
      {
        path: "connect-accounts",
        component: () =>
          import("../views/connect-accounts/ConnectAccountsLayout.vue"),
        meta: {
          activeModule: "connect-accounts",
          activeScreen: "Connect Accounts",
        },
        children: [
          {
            path: "",
            redirect: "account",
          },
          {
            path: "account",
            component: () => import("../views/connect-accounts/Account.vue"),
            meta: {
              activeModule: "connect-accounts",
              activeScreen: "Account Settings",
            },
          },
          {
            path: "ai-configuration",
            component: () =>
              import("../views/connect-accounts/AiConfiguration.vue"),
            meta: {
              activeModule: "connect-accounts",
              activeScreen: "AI Configuration",
            },
          },
          {
            path: "visual-workflow",
            component: () =>
              import("../views/connect-accounts/VisualWorkflow.vue"),
            meta: {
              activeModule: "connect-accounts",
              activeScreen: "Visual Workflow",
            },
          },
        ],
      },
      {
        path: "admin/support",
        name: "ProblemSupport",
        component: () => import("../admin/ProblemSupport.vue"),
        meta: { activeModule: "admin", activeScreen: "Problem Support" },
      },
      {
        path: "/welcome",
        name: "Welcome",
        component: () => import("@/views/Welcome.vue"),
        meta: { activeModule: "welcome", activeScreen: "Welcome" },
      },
      {
        path: "help",
        component: () => import("../views/Help.vue"),
        meta: { activeModule: "help", activeScreen: "Help" },
        children: [
          {
            path: "analytics-dashboard",
            name: "Module1",
            component: () => import("@/views/Module1.vue"),
            meta: { activeModule: "help", activeScreen: "Analytics Help" },
          },
          {
            path: "ai-messaging",
            name: "AIMessaging",
            component: () => import("@/views/AIMessaging.vue"),
            meta: { activeModule: "help", activeScreen: "AI Messaging Help" },
          },
          {
            path: "content-calendar",
            name: "ContentCalendar",
            component: () => import("../views/ContentCalendar.vue"),
            meta: {
              activeModule: "help",
              activeScreen: "Content Calendar Help",
            },
          },
          {
            path: "Subscription-ppv",
            name: "SubscriptionPPV",
            component: () => import("../views/SubscriptionPPV.vue"),
            meta: {
              activeModule: "help",
              activeScreen: "Subscription & PPV Help",
            },
          },
          {
            path: "advance-revenue-optimization",
            name: "RevenueOptimizationModule",
            component: () => import("../views/AdvanceRevenueOptimization.vue"),
            meta: {
              activeModule: "help",
              activeScreen: "Revenue Optimization Help",
            },
          },
          {
            path: "smart-content",
            name: "SmartContetnt",
            component: () => import("../views/SmartContent.vue"),
            meta: { activeModule: "help", activeScreen: "Smart Content Help" },
          },
          {
            path: "security-privacy",
            name: "SecurityPrivacy",
            component: () => import("../views/securityPrivacy.vue"),
            meta: {
              activeModule: "help",
              activeScreen: "Security Privacy Help",
            },
          },
          {
            path: "Onboarding-Migration",
            name: "OnboardingMigration",
            component: () => import("../views/OnboardingAndMigration.vue"),
            meta: {
              activeModule: "help",
              activeScreen: "Onboarding Migration Help",
            },
          },
          {
            path: "connect-accounts",
            name: "ConnectAccounts",
            component: () => import("../views/ConnectAccounts.vue"),
            meta: {
              activeModule: "help",
              activeScreen: "Mobile Experience Help",
            },
          },
          {
            path: "fan-database",
            name: "FanDatabase",
            component: () => import("../views/FanDatabase.vue"),
            meta: { activeModule: "help", activeScreen: "Fan Database Help" },
          },
          {
            path: "mobile-experience",
            name: "MobileExperienceHelp",
            component: () => import("../views/MobileExperienceHelp.vue"),
            meta: {
              activeModule: "help",
              activeScreen: "Mobile Experience Help",
            },
          },
          {
            path: "Api-Intrigation",
            name: "ApiIntrigation",
            component: () => import("../views/APIIntegration.vue"),
            meta: {
              activeModule: "help",
              activeScreen: "API Integration Help",
            },
          },
        ],
      },
      {
        path: "",
        redirect: "dashboard",
      },
    ],
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: { requiresAuth: false, activeModule: "auth", activeScreen: "Login" },
  },
  {
    path: "/signup",
    name: "Signup",
    component: Signup,
    meta: { requiresAuth: false, activeModule: "auth", activeScreen: "Signup" },
  },
  {
    path: "/reset-password/:token",
    name: "ResetPassword",
    component: ResetPassword,
    meta: {
      requiresAuth: false,
      activeModule: "auth",
      activeScreen: "Reset Password",
    },
  },
  {
    path: "/cancellation-policy",
    name: "CancellationPolicy",
    component: CancellationPolicy,
    meta: {
      requiresAuth: false,
      activeModule: "policies",
      activeScreen: "Cancellation Policy",
    },
  },
  {
    path: "/refund-policy",
    name: "RefundPolicy",
    component: RefundPolicy,
    meta: {
      requiresAuth: false,
      activeModule: "policies",
      activeScreen: "Refund Policy",
    },
  },
  {
    path: "/privacy-policy",
    name: "PrivacyPolicy",
    component: PrivacyPolicy,
    meta: {
      requiresAuth: false,
      activeModule: "policies",
      activeScreen: "Privacy Policy",
    },
  },
  {
    path: "/terms-and-conditions",
    name: "TermsAndConditions",
    component: TermsAndConditions,
    meta: {
      requiresAuth: false,
      activeModule: "policies",
      activeScreen: "Terms & Conditions",
    },
  },
  {
    path: "/about-us",
    name: "AboutUs",
    component: AboutUs,
    meta: {
      requiresAuth: false,
      activeModule: "about",
      activeScreen: "About Us",
    },
  },
  {
    path: "/legals",
    name: "Legals",
    component: Legals,
    meta: {
      requiresAuth: false,
      activeModule: "legals",
      activeScreen: "Legals",
    },
  },
  {
    path: "/contact",
    name: "Contact",
    component: () => import("../views/Contact.vue"),
    meta: {
      requiresAuth: false,
      activeModule: "contact",
      activeScreen: "Contact",
    },
  },
  // Catch all 404 route
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: NotFound,
    meta: {
      requiresAuth: false,
      activeModule: "error",
      activeScreen: "404 Not Found",
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const publicPages = [
    "/",
    "/login",
    "/signup",
    "/reset-password/",
    "/welcome",
    "/cancellation-policy",
    "/refund-policy",
    "/privacy-policy",
    "/terms-and-conditions",
    "/about-us",
    "/legals",
  ];
  const authRequired =
    !publicPages.includes(to.path) && !to.path.startsWith("/reset-password/");
  const loggedIn = localStorage.getItem("token");

  if (authRequired && !loggedIn) {
    return next("/login");
  }

  // If user is logged in and tries to access login page, redirect to dashboard
  if (loggedIn && to.path === "/login") {
    return next("/dashboard");
  }

  next();
});

export default router;
